import idb from '@/store/services/idb';
import { WsCalls } from '@/store/services/wsCalls';

// initial state
const state = () => ({
  produtos: [],
  family: [],
  count: 0,
  likes: [],
  loadingProducts: true,
  loadingProduct: true,
  lastLoading: null,
})

// getters
const getters = {
  getProdutosFeed: (state) => {
    return state.produtos;
  },
  getFamily: (state) => {
    return state.family;
  },
  getCount: (state) => {
    return state.count;
  },
  getLikeByIdProduto: (state) => (sku) => {
      return state.likes.find(like => like.id.split("_")[1] == sku);
  },
  getProdutoById: (state) => (sku) => {
      return state.produtos.find(produto => produto.sku == sku);
  },
  getProdutoByBarcode: (state) => (barcode) => {
      return state.produtos.find(produto => produto.barcode == barcode);
  },
  getProdutosFeedOrdered: (state) => (order) => {
    let produtos = state.produtos;
    if(order != null){
      switch(order){
        case 0:
          produtos.sort((a, b) => {
              let fa = a.name.toLowerCase(), fb = b.name.toLowerCase();
              if (fa < fb) return -1;
              if (fa > fb) return 1;
              else return 0;
          });
        break;
        case 1:
          produtos.sort((a, b) => {
              let fa = a.name.toLowerCase(), fb = b.name.toLowerCase();
              if (fa < fb) return 1;
              if (fa > fb) return -1;
              else return 0;
          });
        break;
        case 2:
          produtos.sort((a, b) => b.price - a.price);
        break;
        case 3:
          produtos.sort((a, b) => a.price - b.price);
        break;
      }
    }
    return produtos;
  },
}

// actions
const actions = {
  async getProductDetails ({ commit, rootGetters }, parametros ) {
    return new Promise((resolve) => {
      commit('setLoadingProduct', true);
      WsCalls.callMethodWS('GET', 'productDetails', rootGetters['main/getConfig'], parametros).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          commit('setLoadingProduct', false);
          resolve(response.data.return.product);
        } else {
          commit('setLoadingProduct', false);
          resolve(false);
        }
      });
    })
  },
  async getProdutos ({ commit, state, rootGetters }, { type, parametros, filter_price = null }) {
    return new Promise((resolve) => {
      let lastLoading = Math.floor(Math.random() * 1000);
      commit('setLastLoading', lastLoading);
      
      if(parametros.split("/")[0] == "0"){
        commit('setLoadingProducts', true);
      }
      let headers = null;
      if(filter_price != null){
        headers = {
          minvalue: filter_price[0],
          maxvalue: filter_price[1]
        }
      }
      WsCalls.callMethodWS('GET', type, rootGetters['main/getConfig'], parametros, headers).then(function (response) {
        if(state.lastLoading == lastLoading){
          if (response.data.cod == 100 && response.data.return.products != null && response.data.return.products.length > 0) {
            if(parametros.split("/")[0] == "0"){
              commit('setProdutos', response.data.return.products);
              commit('setCount', response.data.return.count);
            } else {
              commit('concatProdutos', response.data.return.products);
            }
            commit('setLoadingProducts', false);
            resolve(true);
          } else {
            if(parametros.split("/")[0] == "0"){
              commit('setProdutos', []);
              commit('setCount', 0);
            }
            commit('setLoadingProducts', false);
            resolve(false);
          }
          commit('setLastLoading', null);
        }
      });
    });
  },
  async buscaProdutosResume ({ rootGetters }, parametros) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('POST', 'findProductResume', rootGetters['main/getConfig'], parametros).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          let retorno = [];
          if(response.data.return.products != null && response.data.return.products.length > 0){
            retorno = response.data.return.products;
          }
          if(response.data.return.offers_elf != null && response.data.return.offers_elf.length > 0){
            retorno = retorno.concat(response.data.return.offers_elf);
          }
          resolve(retorno);
        } else {
          resolve(false);
        }
      });
    })
  },
  async buscaProdutos ({ commit, rootGetters }, parametros) {
    return new Promise((resolve) => {
      commit('setLoadingProducts', true);
      WsCalls.callMethodWS('POST', 'findProduct', rootGetters['main/getConfig'], parametros).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          let retorno = [];
          if(response.data.return.products != null && response.data.return.products.length > 0){
            retorno = response.data.return.products;
          }
          if(response.data.return.offers_elf != null && response.data.return.offers_elf.length > 0){
            retorno = retorno.concat(response.data.return.offers_elf);
          }
          commit('setProdutos', retorno);
          commit('setCount', response.data.return.products.length + response.data.return.offers_elf.length);
          commit('setLoadingProducts', false);
          resolve(response.data.return.find_by != undefined ? response.data.return.find_by : "");
        } else {
          commit('setProdutos', []);
          commit('setCount', 0);
          commit('setLoadingProducts', false);
          resolve("");
        }
      });
    })
  },
  async getProdutosCarousel ({ rootGetters }, { type, parametros }) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', type, rootGetters['main/getConfig'], parametros).then(function (response) {
        if (response.data.cod == 100 && response.data.return.products != null) {
          resolve(response.data.return.products);
        } else {
          resolve(false);
        }
      });
    })
  },
  async getProdutosRelacionados ({ rootGetters }, parametros ) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'related', rootGetters['main/getConfig'], null, parametros).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          resolve(response.data.return);
        } else {
          resolve(false);
        }
      });
    })
  },
  async getFavorites ({ commit, rootGetters }, { parametros }) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'favorites', rootGetters['main/getConfig'], parametros).then(function (response) {
        if (response.data.cod == 100 && response.data.return.products != null && response.data.return.products.length > 0) {
          if(parametros.split("/")[0] == "0"){
            commit('setProdutos', response.data.return.products);
            commit('setCount', response.data.return.count);
          } else {
            commit('concatProdutos', response.data.return.products);
          }
          resolve(true);
        } else {
          if(parametros.split("/")[0] == "0"){
            commit('setProdutos', []);
            commit('setCount', 0);
          }
          resolve(false);
        }
      });
    })
  },
  async getExtraImages ({ rootGetters }, parametros ) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'extraImages', rootGetters['main/getConfig'], null, parametros).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null && response.data.return.length > 0) {
          resolve(response.data.return);
        } else {
          resolve(false);
        }
      });
    })
  },
  async getImageCarousel ({ rootGetters }, parametros) {
    return new Promise((resolve) => {
      if(parametros.imghash != "" && parametros.imghash != "t-"){
        WsCalls.callMethodWS('IMAGE', 'servicesImage', rootGetters['main/getConfig'], parametros.imghash).then(function (response) {
          if (response.data.type == 'application/json') {
            resolve('no-image');
          } else {
            resolve(URL.createObjectURL(response.data));
          }
        }).catch(() => {
          resolve('no-image');
        });
      } else {
        resolve('no-image');
      }
    })
  },
  async getImage ({ commit, rootGetters }, parametros) {
    return new Promise((resolve) => {
      if(parametros.imghash != "" && parametros.imghash != "t-"){
        WsCalls.callMethodWS('IMAGE', 'servicesImage', rootGetters['main/getConfig'], parametros.imghash).then(function (response) {
          if (response.data.cod == 404) {
            commit('setImage', { "sku": parametros.sku, "image": 'no-image' });
            resolve(true);
          } else {
            commit('setImage', { "sku": parametros.sku, "image": URL.createObjectURL(response.data) });
            resolve(true);
          }
        }).catch(() => {
          commit('setImage', { "sku": parametros.sku, "image": 'no-image' });
        });
      } else {
        commit('setImage', { "sku": parametros.sku, "image": 'no-image' });
        resolve(true);
      }
    })
  },
  async loadFamily ({ commit, rootGetters }, parametros) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'offerFamily', rootGetters['main/getConfig'], parametros).then(function (response) {
        if (response.data.cod == 100 && response.data.return.products != null) {
          commit('setFamily', response.data.return.products);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    })
  },
  async setLikeProduto ({ commit, rootState }, sku) {
    var id =  rootState.user.isu + "_" + sku;
    commit('addLikes', { "id" : id, "isu": rootState.user.isu });
    await idb.loadData('likes', { "id" : id, "isu": rootState.user.isu });
  },
  async removeLikeProduto ({ commit, rootState }, sku) {
    var id =  rootState.user.isu + "_" + sku;
    commit('removeLikes', id);
    await idb.deleteData('likes', id);
  },
  async getLikes ({ commit, rootState }) {
    if(await idb.getData('likes')){
      return commit('loadLikes', { "likes": await idb.getData('likes'), "isu": rootState.user.isu });
    }
  },
  addProduct ({ commit }, product) {
    commit('setProdutos', [ product ]);
  },
  async connectActivate ({ commit, dispatch, rootGetters }, parametros, add) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('POST', 'connectActivate', rootGetters['main/getConfig'], { "offer_id": parametros.offer.offer_id }).then(function (response) {
        if (response.data.cod == 200) {
          commit('setDhActivated', { "sku": parametros.sku, "dh_activated": response.data.return.dh_activated });

          if(add == true)
            dispatch("cart/loadItensCart", null, { root: true });

          resolve(response.data.return.dh_activated);
        } else {
          resolve(false);
        }
      });
    });
  },
  async shareOffer ({ rootGetters }, parametros) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('POST', 'shareOffer', rootGetters['main/getConfig'], parametros).then(function () {
        resolve(true);
      });
    });
  },
  async getFullProduct ({ rootGetters }, parametros) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'fullproduct', rootGetters['main/getConfig'], null, parametros).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          resolve(response.data.return);
        } else {
          resolve(null);
        }
      });
    })
  },
  async getInfoNutri ({ rootGetters }, parametros) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'infonutri', rootGetters['main/getConfig'], null, parametros).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          resolve(response.data.return);
        } else {
          resolve(null);
        }
      });
    })
  },
}

// mutations
const mutations = {
  setProdutos (state, produtos) {
    state.produtos = produtos;
  },
  setFamily (state, family) {
    state.family = family;
  },
  setCount (state, count) {
    state.count = count;
  },
  concatProdutos (state, produtos) {
    state.produtos = state.produtos.concat(produtos);
  },
  setImage (state, { sku, image }) {
    var produto = state.produtos.find(p => p.sku == sku);
    if(produto != undefined){
      produto.image = image;
    }
  },
  loadLikes: (state, { likes, isu }) => {
    state.likes.splice(0, state.likes.length);
    if (likes.length > 0) {
      likes.forEach(function(element) {
        if(element.isu == isu){
            state.likes.push(element);
        }
      });
    }
  },
  addLikes: (state, like) => {
    state.likes.push(like);
  },
  removeLikes: (state, like) => {
    var index = [];
    state.likes.find(function(item, i){
      if(item.id == like){
        index.push(i);
        return i;
      }
    });
    if (index.length > 0) {
      index.forEach(function(element) {
          state.likes.splice(element, 1);
      });
    }
  },
  setDhActivated (state, { sku, dh_activated }) {
    var produto = state.produtos.find(p => p.sku == sku);
    if(produto != undefined){
      produto.dh_activated = dh_activated;
    }
  },
  setLoadingProducts (state, status) {
    state.loadingProducts = status;
  },
  setLoadingProduct (state, status) {
    state.loadingProduct = status;
  },
  setLastLoading (state, i) {
    state.lastLoading = i;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}